var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLive = function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "live_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M480 618.784V514.08l73.056 50.976zm146.304-80.672-160-111.68a32 32 0 0 0-44.544 8 31.49 31.49 0 0 0-4.224 26.624c-.64 2.528-1.536 4.96-1.536 7.68v192c0 3.936.928 7.68 2.272 11.2a31.36 31.36 0 0 0 3.936 29.088 32 32 0 0 0 44.768 6.784l160-117.696a32.032 32.032 0 0 0-.672-52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M224 804.704v-480h576l.256 480zm576.256-544h-188.8l40.096-87.36a32 32 0 1 0-58.208-26.688l-52.288 114.048H459.52L407.2 146.656a32 32 0 1 0-58.176 26.688l40.064 87.36H223.744a63.936 63.936 0 0 0-63.744 64v480c0 35.296 28.608 64 63.744 64h576.512a63.936 63.936 0 0 0 63.744-64v-480c0-35.296-28.608-64-63.744-64"
  })));
};
export default SvgLive;